// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--UWUeo";
export var button = "styles-module--button--z2YTM";
export var code = "styles-module--code--TjboK";
export var container = "styles-module--container--bJBo9";